import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/games_panel.css */
  .menu_select {
    width: 18px;
    height: 18px;
    background: hsla(0, 0%, 0%, 0.2) url(${icons.arrow_up}) center 4px / auto 9px no-repeat;
    filter: invert(1);
    border-radius: 3px;
    cursor: pointer;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/lb_bids_stats.css */
  @media (max-width: 1600px) {
    .select-box {
      position: relative;
      display: block;
      font-weight: 600;
      width: 100%;
      white-space: nowrap;
      cursor: pointer;
      background: transparent;
      border-bottom: 0;
      display: flex;
      border-radius: 10px;
      color: var(--primary-text-color);
      font-size: 0.75rem;
      align-items: center;
    }
    .select-box__current {
      position: relative;
      cursor: pointer;
      width: fit-content;
      border-radius: 10px;
      background: var(--tab-hover-background);
      color: var(--tab-hover-text-color);
      text-shadow: var(--bidding-table-tab-selected-text-shadow);
      padding: 12px 60px 10px 20px;
    }
    .select-box__current.component {
      padding: 0 60px 0 20px;
    }
    .select-box__input-text:hover {
      background: var(--input-background);
    }
    .select-box__input:checked + .select-box__input-text:hover {
      background: transparent;
    }
    .select-box__current:focus + .select-box__list {
      opacity: 1;
      animation-name: none;
    }
    .select-box__current:focus + .select-box__list .select-box__option {
      cursor: pointer;
    }
    .select-box__current:focus .menu_select {
      transform: translateY(-50%) rotate(0);
    }
    .menu_select {
      position: absolute;
      top: 50%;
      right: 15px;
      transform: translateY(-50%) rotate(180deg);
      width: 20px;
      opacity: 1;
      transition: 0.5s ease;
    }
    .select-box__value {
      display: flex;
    }
    .select-box__input {
      display: none;
    }
    .select-box__input:checked + .select-box__input-text {
      display: flex;
      align-items: center;
    }
    .select-box__input-text {
      display: none;
      /* background: var(--tab-section-background); */
      border-radius: 10px;
    }
    .select-box__list {
      position: absolute;
      width: max-content;
      padding: 0;
      list-style: none;
      opacity: 0;
      animation-name: HideList;
      animation-duration: 0.5s;
      animation-delay: 0.5s;
      animation-fill-mode: forwards;
      animation-timing-function: step-start;
      box-shadow: 0px 5px 8px 0px rgba(0, 0, 0, 0.5);
      -webkit-backdrop-filter: blur(20px);
      backdrop-filter: blur(20px);
      font-size: 0.8rem;
      background: var(--tab-section-background);
      border-radius: 10px;
      top: 0;
      z-index: 2;
    }
    .select-box__option {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      padding: 14px 15px 12px 15px;
      -webkit-backdrop-filter: blur(20px);
      backdrop-filter: blur(20px);
      white-space: break-spaces;
    }
    .select-box__option.component {
      padding: 0 0 0 5px;
    }
    li:first-child .select-box__option {
      border-radius: 10px 10px 0 0;
    }
    li:last-child .select-box__option {
      border-radius: 0 0 10px 10px;
    }
    .select-box__option:hover,
    .select-box__option:focus {
      background: hsla(221, 16%, 85%, 0.2);
      backdrop-filter: blur(20px);
    }
  }
  @media (max-width: 600px) {
    .select-box {
      font-size: 0.8rem;
    }
    .select-box__current {
      padding: 12px 40px 10px 10px;
    }
    .menu_select {
      right: 10px;
    }
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/res.css */
  @media (max-width: 430px) {
    .menu_select {
      width: 14px;
      height: 14px;
      background: hsla(0, 0%, 0%, 0.2) url(${icons.arrow_up}) center 2px / auto 9px no-repeat;
    }
  }
  /*! CSS Used keyframes */
  @keyframes HideList {
    from {
      transform: scaleY(1);
    }
    to {
      transform: scaleY(0);
    }
  }
  @keyframes HideList {
    from {
      transform: scaleY(1);
    }
    to {
      transform: scaleY(0);
    }
  }
`

const developerCSS = css``

export const DropDownTabsCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
